import React from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Check } from "lucide-react";
import rightArrowIcon from "../../../assets/new icons/extraction review/right arrow.svg";
import { fontFamily } from "../../Constants/constants";

interface ExtractionSuccessModalProps {
  open: boolean;
  successFilename: string | null;
  onClose: () => void;
  onGoToExtractionReview: () => void;
}

export default function ExtractionSuccessModal({
  open,
  successFilename,
  onClose,
  onGoToExtractionReview,
}: ExtractionSuccessModalProps) {
  return (
    <Modal
      open={open}
      onClose={(_event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      aria-labelledby="extraction-success-modal-title"
      aria-describedby="extraction-success-modal-description"
      style={{ border: "none", background: "transparent", boxShadow: "none" }}
    >
      <div
        style={{
          top: "50%",
          left: "50%",
          border: "none",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          width: "460px",
          padding: "36px 32px 28px",
          outline: "none",
          backgroundColor: "white",
          boxShadow: "none",
          borderRadius: "16px",
          textAlign: "center",
        }}
      >
        {/* Close icon */}
        <div
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            marginRight: 20,
            width: 24,
            height: 24,
            backgroundColor: "var(--pack-background-opacity)",
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <CloseIcon style={{ fontSize: 14, opacity: 1.0, color: "var(--pack-header-text)" }} />
        </div>

        {/* Top card — checkmark + filename + label */}
        <div
          style={{
            background: "var(--extraction-sucess-header-bg)",
            borderRadius: 12,
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            gap: 14,
            marginTop: 40,
            marginBottom: 20,
            textAlign: "left",
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              backgroundColor: "var(--pack-background-opacity-success)",
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Check style={{ fontSize: 14, color: "var(--application-primary-color)" }} />
          </div>
          <div>
            <div
              style={{
                fontFamily,
                fontSize: 14,
                fontWeight: 700,
                color: "var(--pack-header-text)",
                wordBreak: "break-all",
                marginBottom: 2,
              }}
            >
              {successFilename ?? ""}
            </div>
            <div
              style={{
                fontFamily,
                fontSize: 13,
                fontWeight: 500,
                color: "var(--pack-progress-bg)",
              }}
            >
              Extraction Successful
            </div>
          </div>
        </div>

        {/* Description */}
        <p
          style={{
            fontFamily,
            fontSize: 16,
            color: "var(--pack-body-text)",
            marginBottom: 28,
            lineHeight: 1.6,
            textAlign: "start",
          }}
        >
          Extraction completed. The file has been successfully pushed to Extraction Review.
        </p>

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "center", gap: 14 }}>
          <Button
            disableElevation
            variant="outlined"
            style={{
              fontFamily,
              width: 160,
              height: 40,
              borderRadius: "3.56px",
              borderColor: "var(--application-primary-color)",
              color: "var(--application-primary-color)",
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
            }}
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            disableElevation
            variant="contained"
            disableRipple
            className="workload-process-btn"
            endIcon={<img src={rightArrowIcon} alt="→" />}
            onClick={onGoToExtractionReview}
          >
            Extraction Review
          </Button>
        </div>
      </div>
    </Modal>
  );
}
